import React from 'react';
import { FormControl, FormHelperText, FormGroup, Theme, makeStyles, createStyles, Grid } from '@material-ui/core';
import { CLAIM_FORMAT_TYPES, CLAIM_PROPERTIES } from '@app/pages/ssoManager/addEditApplication.enums';
import { useTypedTranslation } from '@app/hooks';
import { PasslyTextField } from '@app/components';
import { TranslationsTypes } from '@app/models';
import { Autocomplete } from '@material-ui/lab';

interface IProps {
    newAttributeClaimFormat: string;
    newAttributeClaimDisplayName: string;
    newAttributeClaimAttributeName: string;
    newAttributeClaimAttributeNameQualifier: string;
    newAttributeClaimSPNameQualifier: string;
    newAttributeClaimSPProvidedId: string;
    onChange: (name: string, value: string) => void;
}

interface IField {
    type: string;
    id: string;
    name: string;
    value: string;
    label: TranslationsTypes;
    data?: string[];
    title?: string;
    helpText?: TranslationsTypes;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        marginBottom: theme.spacing(2),
      },
    },
  }),
);

export const ExtendedPropertiesComponent: React.SFC<IProps> = (props: IProps) => {

    const { translation } = useTypedTranslation();

    const classes = useStyles();

    const fields: IField[] = [
        {
            type: 'select',
            id: 'addAttrFormatSelector-input',
            name: 'newAttributeClaimFormat',
            value: props.newAttributeClaimFormat,
            data: CLAIM_FORMAT_TYPES,
            label: 'CLAIM_FORMAT_TYPE',
            helpText: 'CLAIM_FORMAT_TYPE_EXTENDED_HELP'
        },
        {
            type: 'text',
            id: 'claimDisplayName-input',
            title: CLAIM_PROPERTIES.DisplayName,
            value: props.newAttributeClaimDisplayName,
            name: 'newAttributeClaimDisplayName',
            label: 'DISPLAY_NAME'
        },
        {
            type: 'text',
            id: 'claimAttrName-input',
            title: CLAIM_PROPERTIES.AttributeNameFormat,
            value: props.newAttributeClaimAttributeName,
            name: 'newAttributeClaimAttributeName',
            label: 'ATTRIBUTE_NAME'
        },
        {
            type: 'text',
            id: 'claimAttrNameQualifier-input',
            title: CLAIM_PROPERTIES.NameQualifier,
            value: props.newAttributeClaimAttributeNameQualifier,
            name: 'newAttributeClaimAttributeNameQualifier',
            label: 'ATTRIBUTE_NAME_QUALIFIER'
        },
        {
            type: 'text',
            id: 'claimSpNameQualifier-input',
            title: CLAIM_PROPERTIES.SPNameQualifier,
            value: props.newAttributeClaimSPNameQualifier,
            name: 'newAttributeClaimSPNameQualifier',
            label: 'SP_NAME_QUALIFIER'
        },
        {
            type: 'text',
            id: 'claimSpProvidedId-input',
            title: CLAIM_PROPERTIES.SPProvidedID,
            value: props.newAttributeClaimSPProvidedId,
            name: 'newAttributeClaimSPProvidedId',
            label: 'SP_PROVIDED_ID'
        }
    ];

    return (
        <Grid container>
            <Grid item md={7}>
                {fields.map((field, index) => {

                    return (
                        <FormGroup key={index} className={classes.root}>
                            {field.type === 'select' ? (
                                <FormControl>
                                    <Autocomplete
                                        id={field.id}
                                        freeSolo
                                        autoSelect
                                        options={field!.data!.map((dataItem) => dataItem)}
                                        value={field.value}
                                        onChange={(event: any, newValue: string | null) => props.onChange(field.name, newValue as string)}
                                        renderInput={(params) => (
                                            <PasslyTextField {...params} label={translation(field.label)} />
                                        )}
                                    />
                                    <FormHelperText>{translation(field.helpText ?? '')}</FormHelperText>
                                </FormControl>
                            ) : (
                                <FormControl>
                                    <PasslyTextField
                                        id={field.id}
                                        label={field.label}
                                        title={field.title}
                                        value={field.value}
                                        name={field.name}
                                        onChange={({target: {name, value}}) => props.onChange(name as string, value as string)}
                                        fullWidth
                                    />
                                </FormControl>
                            )}
                        </FormGroup>
                    );
                })}
            </Grid>
        </Grid>
    );
};
